'use client'
import Link from 'next/link'
import { navigation } from './config'
import { usePathname } from 'next/navigation'

const footerNavs = [
  { name: 'Privacy', href: '/privacy' },
  { name: 'Terms', href: '/terms' },
  { name: 'Cookies', href: '/terms' },
]
const footerLinks = [
  { name: 'Overview', href: 'Overview' },
  { name: 'Niyo Fest Hackathon', href: 'Competitions' },
  { name: 'About', href: 'About' },
  { name: 'Apply Now', href: '/niyo/apply?referer=hackathon' },
  { name: 'Privacy', href: '/privacy' },
]
export function Footer() {
  const pathname = usePathname(null)

  const isNiyo = pathname?.includes('niyo')
  const isIndia = pathname?.startsWith('/india')
  
  // India pages use their own footer from the India layout
  if (isIndia) return null
  
  return isNiyo ? (

    <footer
      className="bg-[#141414] relative w-full pt-[64px] px-0 pb-[48px] "
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>

      <div className="max-w-7xl w-full px-14 mx-auto">
        <div className="flex-col flex gap-2 items-center">
          <Link href="/" className="pb-6">
            <img className="w-64 " src="/logo_white.svg" alt="AI Forge Logo" />
          </Link>

          <ul className=" flex justify-center flex-wrap gap-4 items-center pb-[48px]">
            {footerLinks.map((item) => (
              <li key={item.name}>
                {item.href.includes('/') ? (
                  <Link
                    href={item.href}
                    className="text-base font-[600] !no-underline !text-[#EAECF0] hover:text-white"
                  >
                    {item.name}
                  </Link>
                ) : (
                  <a
                    href={'#' + item.href}
                    className="text-base font-[600] !no-underline !text-[#EAECF0] hover:text-white"
                  >
                    {item.name}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="w-full mt-8 border-t border-[#424242] pt-8 flex flex-col md:flex-row items-center justify-between">
          <div className="flex gap-4 ">
            {footerNavs.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                className="!no-underline !text-[#D0D5DD] hover:text-gray-400"
              >
                <span className="">{item.name}</span>
                {/* <item.icon className="h-6 w-6" aria-hidden="true" /> */}
              </a>
            ))}
          </div>
          <p className="mt-8  leading-5 !no-underline !text-[#D0D5DD] md:order-1 md:mt-0 sm:text-left text-center ">
            &copy; {new Date().getFullYear()} AI Forge, Inc. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  ) : (
    <footer
      className="bg-gradient-to-r from-[#02090e] to-[#01080c] relative w-full"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
        <div className="flex-col md:flex-row flex gap-20  xl:grid xl:grid-cols-3 xl:gap-8">
          <Link href="/" className="pb-6">
            <img className="w-64 " src="/logo_white.svg" alt="AI Forge Logo" />
          </Link>
          <div className=" grid gap-8 xl:col-span-2 xl:mt-0">
            <div className=" flex items-center justify-around md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-white">
                  Company
                </h3>
                <ul className="mt-6 space-y-4">
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <Link
                        href={item.href}
                        className="text-sm leading-6 !no-underline !text-gray-300 hover:text-white"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-white">
                  Legal
                </h3>
                <ul className="mt-6 space-y-4">
                  {navigation.legal.map((item) => (
                    <li key={item.name}>
                      <Link
                        href={item.href}
                        className="text-sm leading-6 !no-underline !text-gray-300 hover:text-white"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8 border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between">
          <div className="flex space-x-6 md:order-2">
            {navigation.social.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                className="!no-underline !text-gray-500 hover:text-gray-400"
              >
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-6 w-6" aria-hidden="true" />
              </a>
            ))}
          </div>
          <p className="mt-8 text-xs leading-5 !no-underline !text-gray-400 md:order-1 md:mt-0">
            &copy; {new Date().getFullYear()} AI Forge, Inc. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
